import React, { useState, useEffect } from 'react';
import Header from '../../dashboard/header';
import Navbar from '../../dashboard/navbar';
import Sidebar from '../../dashboard/sidebar';
import { useLocation, useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import useAuth from '../../dashboard/useAuth';
import axios from 'axios';

const Ajouter_diffusion = ({ titre }) => {
    useAuth();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    const user_id = localStorage.getItem('user_id');
    const navigate = useNavigate();
    const [alert, setAlert] = useState({ message: '', type: '' });

    const [formData, setFormData] = useState({
        nom: '',
        description: '',
        statut: 'inactif',
    });

    const showAlert = (message, type = 'success') => {
        setAlert({ message, type });
        setTimeout(() => {
            setAlert({ message: '', type: '' });
        }, 5000);
    };

    useEffect(() => {
        if (user_id) {
            document.title = "eTrainApp | Ajouter Liste de Diffusion";
        }
    }, [user_id]);

    const handleSubmit = async (event) => {
        event.preventDefault();
        const data = {
            nom: formData.nom,
            description: formData.description,
            statut: formData.statut,
        };
    
        try {
            const response = await fetch(process.env.REACT_APP_HOTE + `/ajouter-liste-diffusion/${user_id}/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            });
            
            const responseData = await response.json(); // On lit la réponse une seule fois
            
            if (!response.ok) {
                console.error('Erreur:', responseData);
                showAlert(responseData.error || "Une erreur est survenue", "danger");
            } else {
                console.log('Succès:', responseData);
                showAlert("La liste de Diffusion créée avec succès !", "success");
                navigate(`/Liste-diffusion`);
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
            showAlert("Erreur réseau. Veuillez réessayer.", "danger");
        }
    };

    const handleCancel = () => {
        setFormData({
            nom: '',
            description: '',
            ordre: '',
        });
    };

    const modules = {
        toolbar: [
            [{ 'header': [1, 2, false] }],
            ['bold', 'italic', 'underline'],
            ['link', 'image'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            ['clean'],
            [{ 'align': [] }],
        ],
    };



    const [accesGroupe, setAccesGroupe] = useState([]);
    const [groupeId, setGroupeId] = useState(null);
    const groupe = localStorage.getItem('groupe');

    const verifGroupe = async () => {
        const groupeStored = localStorage.getItem('groupe');
        const accesGroupeStored = localStorage.getItem('accesGroupe');

        if (groupeStored && accesGroupeStored) {
            setGroupeId(groupeStored);
            setAccesGroupe(JSON.parse(accesGroupeStored));
        } else {
            try {
                const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}`);
                if (response.status === 200) {
                    const data = response.data;
                    setGroupeId(data.groupe);

                    let cleanedAccessArray = [];
                    if (Array.isArray(data.acces)) {
                        cleanedAccessArray = data.acces.map((item) =>
                            item.acces
                                ? item.acces.replace(/[\[\]']/g, '').trim().split(',').map((access) => access.trim())
                                : []
                        ).flat();

                        setAccesGroupe(cleanedAccessArray);
                    }

                    localStorage.setItem('groupe', data.groupe);
                    localStorage.setItem('accesGroupe', JSON.stringify(cleanedAccessArray));
                }
            } catch (error) {
                // console.error('Erreur lors de la vérification du groupe', error);
            }
        }
    };

    useEffect(() => {
        if (user_id) {
            verifGroupe();
        }
    }, [user_id]);

    if (!accesGroupe.includes("ListeDeDiffusion")) {
        return (
            <div id="wrapper">
                <Sidebar user_id={user_id} titre={titre} />
                <div id="page-wrapper" className="gray-bg">
                    <Navbar />
                    <div className="wrapper wrapper-content animated fadeInRight">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="ibox">
                                    <div className="ibox-content text-center p-5">
                                        <div className="mb-4">
                                            <i className="fa fa-lock fa-5x text-warning"></i>
                                        </div>
                                        <h2>Accès restreint</h2>
                                        <p className="lead mb-4">
                                            Vous n'avez pas les autorisations nécessaires pour accéder à cette page.
                                        </p>
                                        <div className="d-flex justify-content-center">
                                                                                    <Link to="/" className="btn btn-primary">
                                                                                        <i className="fa fa-arrow-left mr-2"></i>
                                                                                        Retour
                                                                                    </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} titre={titre} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <h2 className="mb-1"><i className="fa fa-rss"></i> Nouvelle Diffusion</h2>
                            <small>Administration des Listes diffusions.</small>

                            <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                <ol className="breadcrumb custom-breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/admin`}>Administration</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Liste-diffusion`}>Listes de Diffusion</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Ajouter-diffusion`}>Nouvelle Diffusion</Link>
                                    </li>
                                </ol>
                            </small>
                        </div>
                    </div>

                    <div className="container-fluid"> {/* Ensure full container for responsiveness */}
                        <div className="row justify-content-center">
                            <div className="col-12 col-lg-8 mx-auto mt-5 mb-3"> {/* Use breakpoints for responsive form */}
                                <div className="ibox-content">
                                    <div className="hpanel">
                                        <div className="panel-body">
                                            {alert.message && (
                                                <div className={`alert alert-${alert.type}`}>
                                                    {alert.message}
                                                </div>
                                            )}
                                            <form className="m-t" role="form" onSubmit={handleSubmit} encType="multipart/form-data">
                                                <div className="form-group">
                                                    <label>Nom*</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        required
                                                        name="nom"
                                                        value={formData.nom}
                                                        onChange={(e) => setFormData({ ...formData, nom: e.target.value })}
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label>Description</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="description"
                                                        value={formData.description}
                                                        onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label>Statut*</label>
                                                    <select
                                                        className="form-control m-b"
                                                        name="statut"
                                                        value={formData.statut}
                                                        onChange={(e) => setFormData({ ...formData, statut: e.target.value })}
                                                    >
                                                        <option value="inactif">Inactif</option>
                                                        <option value="actif">Actif</option>
                                                    </select>
                                                </div>

                                                <div className="text-center mt-5">
                                                    <a type="reset" href={`/Liste-diffusion`} className="btn btn-default mr-2">Annuler</a>
                                                    <button type="button" className="btn btn-default mr-2" onClick={handleCancel}>Effacer</button>
                                                    <button type="submit" className="btn btn-success">Enregistrer</button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Ajouter_diffusion;
